<template>
    <component v-bind:is="template"></component>
</template>
<script>
    import i18n from '@/lang'
    export default{
        name: 'contacts_loc',
        
        data() {
            return{
               template:null,
            }
        },
        mounted() {
            try {
                this.template =  require('@/components/contacts/templates/template_'+i18n.locale).default
            }
            catch (e) {
                this.template =  require('@/components/contacts/templates/template_en').default
            }
  }
 

    }
</script>